import { Component, OnInit, Input } from '@angular/core';
import { ShellDomainProvider } from '@ecap3/core';
@Component({
    selector: 'app-loader',
    templateUrl: './app-loader.component.html',
    styleUrls: ['./app-loader.component.scss']
})
export class AppLoaderComponent implements OnInit {
    @Input() LoaderInfo: any;
    backgroundImage: any;

    ngOnInit() {
        this.backgroundImage = `url(${this.LoaderInfo && this.LoaderInfo.backgroundImage})`;
    }

    getStyle() {
        const style = `background-image: url(` + ShellDomainProvider['api']['CdnBaseUrl'] + `grandbasel/assets/images/svg/logo_white.svg)`;
        return style;
    }

}
